import { Component } from '@angular/core';

@Component({
  selector: 'mav-github-icon',
  templateUrl: './github-icon.component.html',
  styleUrls: ['./github-icon.component.scss']
})
export class GithubIconComponent {

  constructor() { }
}
